import script from "./jobDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./jobDetail.vue?vue&type=script&setup=true&lang=js"

import "./jobDetail.vue?vue&type=style&index=0&id=555f868c&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-555f868c"]])

export default __exports__